export default __webpack_public_path__ + "images/f23b96ff0a854071b7abccdad6cb5cdb-2_tablet_1067x470.webp";